/**
 * @Filename: globals.js
 */

;(function(EG) {
  /**
   * @type {Object}
   * This is the Name-spacing for the Users Management WEBAPP
   * All pages should follow this hierarchy
   *  EG.Users.*page-name*
   */
  EG.Users = _.extend(EG.Users, {
    // Common stuff !
    Globals: {},
    Models: {},
    Collections: {},
    Utils: {},
    Libs: {},
    Analytics: {},
    Presenters: {},
    Routes: {},
    ProfileCompletionRoutes: {},
    Callbacks: {},

    // Sub web-apps
    Search: {},
    Profile: {},
    guestBooking : {},
  });

  EG.Users.Globals = {
    LOCALE_SPECIFIC_NAMING_MAP: {
      "firstNameOnly": ['da', 'en', 'es', 'fi', 'fr', 'it', 'nb', 'sv'],
      "lastNameOnly": ['zh'],
      "firstNameAndLastName": ['cs', 'de', 'nl', 'pl', 'pt', 'tr']
    }
  };

  // Users Management Global Constants
  EG.Users.Constants = _.extend(EG.Users.Constants, {
    FORWARD_SLASH: '/',
    USER_SERVICE: EG.Users.Constants.user_service_domain_name + '/v2',
    CUSTOM_ATTR: 'custom',
    SUCCESS_STATUS: 'success',
    alertType: {
      SUCCESS: 'success',
      ERROR: 'error',
      WARN: 'warn'
    },
    USER_STATUS :{

    },
    PRIMARY_INDIVIDUAL_ADDRESS_CODE: '5',
    DOCUMENT_TYPES: {
      PASSPORT: '1',
      DL: '4',
      ID_CARD: '3',
      TSA: '0',
      SPECIAL_DOC: '-1'
    },
    DOCUMENT_TYPES_LABEL: {
      '1': 'PASSPORT',
      '4': 'DL',
      '3': 'ID_CARD',
      '0': 'TSA',
      '5': 'HOME_RETURN_PERMIT',
      '6': 'TAIWAN_COMPATRIOT_PERMIT',
      '7': 'ENTRY_EXIT_PERMIT_FOR_HM',
      '8': 'TRAVEL_PERMIT_FOR_TW',
      '9': 'ARMY_ID',
      '10': 'PERMANENT_RESIDENT_CARD',
      '11': 'DIPLOMATIC_ID',
      '12': 'BIRTH_CERTIFICATE_CARD',
      '13': 'DOMESTIC_TRAVELLING_CARD'
    },
    ADDRESS_TYPES_EU: {
      '5': 'HOME'
    },
    ADDRESS_TYPES_NA: {
      '1': 'HOME'
    },
    INVALID: 'invalid',
    MILLIS_IN_A_DAY: 86400000,
    USER_INFO_FORM_NAME: 'userProfile',
    URL_PARAM_STAGE: 'stage',
    ACTIVE_CLASS: 'active',
    SERVED_FROM_GDM: 'served_from_gdm',
    MAX_MOBILE_VIEW_SCREEN_SIZE: 768,
    costCenters: {
      CC1: 'COST_CENTER_1',
      CC2: 'COST_CENTER_2',
      CC3: 'COST_CENTER_3',
      CC4: 'COST_CENTER_4',
      CC5: 'COST_CENTER_5',
      BDC: 'BDC',
      BDC2: 'BDC2',
      BDCLIST: 'BDCLIST'
    },
    CDF_TYPE: {
      FREE_FIELD: "FREE_FIELD",
      LIST: "LIST"
    },
    PAGE_ORIGIN_PARAM : {
      ARRANGER_GROUP : "arranger_group",
      TRAVELER_GROUP : "traveler_group"
    },
    COMPANY_SETTINGS: {
      COSTCENTER: 'costcenter',
      CC1_CC2_DEPENDENCY_ACTIVATED: 'cc1_cc2_dependency_activated',
      APPROVAL: 'approval',
      DELEGATE_TIME_DELAY: 'delegate_time_delay',
      DEPARTMENTS: -20,
      PRODUCTS: 'products',
      CC1: '27'
    },
    genders: [
      {
        name: 'Male',
        value: '1'
      },
      {
        name: 'Female',
        value: '2'
      },
      {
        name: 'Unspecified',
        value: '3'
      },
      {
        name: 'Undisclosed',
        value: '4'
      }
    ],
    user_genders: [
      {
        name: 'Male',
        value: '1'
      },
      {
        name: 'Female',
        value: '2'
      }
    ],
    user_genders_with_localized_labels: [
      {
        name: uitk.i18n.msg('profile_please_select'),
        value: '0'
      },
      {
        name: uitk.i18n.msg('profile_title_male'),
        value: '1'
      },
      {
        name: uitk.i18n.msg('profile_title_female'),
        value: '2'
      }
    ],
    gender_with_localized_labels: [
      {
        name: uitk.i18n.msg('profile_please_select'),
        value: '0'
      },
      {
        name: uitk.i18n.msg('profile_title_male'),
        value: '1'
      },
      {
        name: uitk.i18n.msg('profile_title_female'),
        value: '2'
      },
      {
        name:  uitk.i18n.msg('profile_gender_undisclosed'),
        value: '3'
      },
      {
        name:  uitk.i18n.msg('profile_gender_unspecified'),
        value: '4'
      }
    ],
    UNDISCLOSED_GENDER_CODE: "4",
    UNSPECIFIED_GENDER_CODE: "3",
    NEUTRAL_TITLE_CODE: "50",
    MR_TITLE_CODE: "1",
    DEFAULT_VALUE: "0",
    NEUTRAL_TITLE: uitk.i18n.msg('profile_title_neutral'),
    US_PROUDUCT_ID: 60000,
    ENABLE: 'enable',
    DISABLE: 'disable',
    APPROVE: 'approve',
    REJECT: 'reject',
    DELETE: 'delete',
    PROFILE_UPDATE: 'PROFILE_UPDATE',
    PARTIAL_UPDATE: 'PARTIAL_UPDATE',
    UPDATE: 'UPDATE',
    CC_UPDATE: 'cc_update',
    COMPANY_CDF_SERVICE_V1: '/cdf-service/v1/companies/',
    ACTIONS_PRODUCTS_SERVICE: '/action-service/v1/products',
    FEE_ORCHESTRATOR_SERVICE: '/fee-orchestrator-service/v1/contactFees',
    KIBANA_ERROR_MESSAGE_FOR_SAVE: '{Module} {component} cannot be saved, server response= {response} and url= {url}',
    KIBANA_ERROR_MESSAGE_FOR_DELETE: '{Module} {component} cannot be deleted, server response= {response} & url= {url}',
    KIBANA_ERROR_MESSAGE_FOR_FETCH: '{Module} {component} cannot be fetched from url= {url}',
    URL_SUFFIX_REFRESH: 'refresh=true',
    URL_SUFFIX_HASH: '#',
    ARRANGER_TYPE_DIRECT: 'DIRECT',
    SSO_USER_MOBILE_LOGIN: 'SSO',
    PANEL_CLOSING_TIMEOUT: 1000,
    LOBS: {
      air: 'air',
      rail: 'rail',
      hotel: 'hotel',
      car: 'car'
    },
    ROLES: {
      mot: '145',
      guest: '55',
      euguest: 'EU55',
      traveler: 'traveler',
      globalGuest: '10001'
    },
    USER_ROLE_TM : 33,
    USER_ROLE_ECT_MEETINGS_ONLY_TRAVELER : 145,
    USER_TYPE:{
      normal:1,
      guest:2,
      globalGuest:3
    },
    SelfRegistrationInvite: {
      types: {
        companyLink: 'COMPANY_WIDE_INVITATION',
        userEmail: 'USER_SPECIFIC_INVITATION'
      }
    },
    ADD:'add',
    PAYMENT_MEANS : {
      ACTIONS: {
          create: 'create',
          delete: 'delete',
          edit: 'edit'
      },
      CARD_TYPE : {
          CC:'CC', // Refers to company Card
          ICCR:'ICCR', // Individual Credit Card
          OOCC:'OOCC', // One off credit card
          EC:'EC' // On Account credit card

      },
      LOB : {
          AIR: {value: 'AIR', order: 0},
          HOTEL: {value: 'HOTEL', order: 1},
          RAIL: {value: 'RAIL', order: 2},
          CAR: {value: 'CAR', order: 3},
          LOW: {value: 'LOW', order: 4},
      },
      SUPPORTED_CARDS : {
          visa: '0',
          mastercard: '1',
          amex: '2',
          discover: '3',
          diners_club_international: '4'
        },
    },
    INTL_TEL_INPUT_CLASS: '.iti',
    ROUTES: {
      ACCOUNT_SETTINGS: {
          value: 'account-settings',
          action: {
            validto: 'validto'
          },
          tab: '#account-settings-tab a',
          scroll: '#account-validity',
          focus: '#expiry_date'
      },
    PERSONAL_INFO: {
        value: 'personal-info',
        action: {
          mobileNumber: 'mobileNumberFocus'
        }
      }
	},
	ADD_CARD_LEGACY_URL: '/pub/agent.dll?qscr=cenb',
	POLICY_HOME_URL: '/policy/global-policy/home',
	ROLES_MAP: {
		role_id_33: 'TravelManager',
		role_id_44: 'Arranger',
		role_id_55: 'Guest',
		role_id_1: 'Traveler',
		role_id_34: 'GlobalArranger',
		role_id_145: 'MeetingsOnlyTraveler',
		role_id_257: 'SecurityManager',
		role_id_206: 'ReportingUser',
		role_id_10002: 'GuestManager',
		role_id_10001: 'GlobalGuest',
        role_id_10004: 'NoBooker',
        role_id_10005: 'EgenciaCommunityUser'
	},
    FETCH_TEMPLATES_URL: EG.Users.Constants.user_service_users_v2_url + `invite-template?company_id=${EG.globalContext.get('managedCompanyId') || EG.user.companyId}`,
    FECTH_TEMPLATE_BY_ID : EG.Users.Constants.user_service_users_v2_url + `invite-template`,
    TG_ERROR_MAP : {
      INVITE_TEMPLATES_ASSOCIATED : uitk.i18n.msg('tg_delete_failure_INVITE_TEMPLATES_ASSOCIATED'),
      USERS_ASSOCIATED_WITH_TRAVELER_GROUP : uitk.i18n.msg('tg_delete_failure_USERS_ASSOCIATED_WITH_TRAVELER_GROUP'),
      DEFAULT_TRAVELER_GROUP : uitk.i18n.msg('tg_delete_failure_DEFAULT_TRAVELER_GROUP'),
      RESOURCE_DOES_NOT_EXISTS : uitk.i18n.msg('tg_delete_failure_RESOURCE_DOES_NOT_EXISTS'),
      DUPLICATE_RECORD_EXCEPTION: uitk.i18n.msg('tg_delete_failure_DUPLICATE_RECORD_EXCEPTION'),
      UNAUTHORIZED_ACCESS: uitk.i18n.msg('tg_delete_failure_UNAUTHORIZED_ACCESS'),
      INTERNAL_ERROR : uitk.i18n.msg('group_alter_error'),
      USER_REMOVAL_FROM_DEFAULT_TRAVELER_GROUP : uitk.i18n.msg('USER_REMOVAL_FROM_DEFAULT_TRAVELER_GROUP')
    },
    NO_LOGIN_ALLOWED_ERROR_MAP: {
      ERR1031 : uitk.i18n.msg('email_reset_error_for_global_guest'),
      ERR1020: uitk.i18n.msg('email_reset_error_for_tne_user'),
      ERR1021: uitk.i18n.msg('email_reset_error_for_legacy_guest'),
      ERR907: uitk.i18n.msg('email_reset_error_when_no_login_rights')
    }
  });

  // Users Management Analytics Constants
  EG.Users.Analytics = {
    pagePrefix: 'page',
    separator: '.',
    PAGE_NAME: 'Users.Profile',
    globalGuest: 'GlobalGuest',
    globalGuestNew: 'GlobalGuestNew',
  };

  // User Management Presenters
  EG.Users.Presenters = {
    mainView: '#main-view',
    subView: '#sub-view'
  };

  /**
   * @type {Object}
   */
  EG.Users.Search = {
    Models: {},
    Collections: {},
    Globals: {},
    Utils: {}
  };

  // User Search Global Space :D
  EG.Users.Search.Globals = {
    Classes: {
      sorting: 'table-sortable'
    },
    ADVANCED: 'ADVANCED',
    ASC: 'ASC',
    USER_STATUS: {
      active: '1',
      inactive: '2',
      deleted: '3',
      pending: '4'
    }
  };

  // User Profile Name-spacing
  EG.Users.Profile = {
    Constants: {},
    Models: {},
    Collections: {},
    Presenters: {},
    Service: {},
    Globals: {},
    Utils: {},
    Analytics: {},
    UserId: undefined,
    Data: {},
    Tests: {},
    View: {
      Utils: {},
      Components: {}
    },
    ABTest: {},
    GraphQL:{
      Assembler: {},
      Schema:{},
      Fragment:{},
      Cache:{},
      Data: {}
    }
  };

  EG.Users.ProfileCompletion = {
    Constants: {},
    Models: {},
    Collections: {},
    Presenters: {},
    Service: {},
    Globals: {},
    Utils: {},
    Analytics: {},
    UserId: undefined,
    Data: {},
    Tests: {},
    View: {
      Utils: {},
      Components: {}
    },
    ABTest: {}
  };

  //User Profile Role Mapper
  var roleMapper = {
    global_arranger: 'Global Arranger',
    travel_manager: 'Travel Manager',
    agent: 'Agent',
    arranger: 'Arranger',
    others: 'Others'
  };

  function mapRoleType(role) {
    var key = role
      .toLowerCase()
      .split(' ')
      .join('_');
    return roleMapper[key];
  }
  // User Profile Global Filters
  EG.Users.Profile.Globals.Filters = {};

  EG.Users.Profile.Globals.isPhoneGlobal = false;
  // User Profile Constants
  EG.Users.Profile.Constants = {
    PROFILE_FORM_NAME: 'userProfile',
    USER_STATUS: {
      active: {
        label: I18n.t('profile_landing_account_status_active'),
        value: '1'
      },
      inactive: {
        label: I18n.t('profile_landing_account_status_inactive'),
        value: '2'
      },
      deleted: {
        label: I18n.t('profile_landing_account_status_deleted'),
        value: '3'
      },
      pending: {
        label: I18n.t('profile_landing_account_status_pending'),
        value: '4'
      }
    },
    OPERTAION_TYPE_KEY: 'opType',
    OPERTAION_TYPE: {
      CREATE: 'create',
      UPDATE: 'update',
      DELETE: 'delete'
    },
    APPROVERS: {
      Substitute: 'Substitute',
      Delegate: 'Delegate',
      Supervisor: 'Supervisor'
    },
    GGU_MIN_AGE_LIMIT: 18
  };

  EG.Users.Profile.ABTest = {
    hasPassport: false,
    viewA: 'view-A',
    viewB: 'view-B',
    viewC: 'view-C'
  };

  // User Profile Presenter Constants
  EG.Users.Profile.Presenters = _.extend({}, EG.Users.Presenters, {
    navigationCardsView: '#navigation-cards',
    subViewHeader: '.sub-view-header',
    HTMLTemplate: ''
  });

  EG.Users.Profile.Globals = _.extend({}, EG.Users.Profile.Globals, {
    isProfileLandingLoaded: false,
    isPhoneGlobal: false, //When phone has same fields for both NA and EU(eg area code, country code, number, extension)
    ContentId: 'sub-view',
    commonMessageContainerId: 'profile-error',
    commonPageMessageContainerId: 'common-page-msg',
    subHeaderId: 'base-user-info',
    InterstitialContainerId: 'main-view',
    messageScrollContainer: $('html, body'),
    navigationHeaderId: 'navigation-header',
    actionBtn: '.btn-action',
    travelerPickerScope: 'user.edit.travelpicker',
    arrangeePickerScope: 'user.edit.arrangeepicker',
    arrangerScope: 'user.arrange.directarrangees',
    globalGuestManagerScope: 'user.manage.guest',
    userManageProfileScope : 'user.manage.profile',
    userCreateGuestScope: 'user.create.guest',
    userMigrateLegacyGuest: 'user.migrate.legacyguest',
    guestUser: 'guest',
    globalGuest: 'global_guest'
  });

  // User Profile Analytics
  EG.Users.Profile.Analytics.PAGE_NAME = EG.Users.Analytics.pagePrefix + EG.Users.Analytics.separator + 'Users.Profile';
  EG.Users.Profile.Analytics.SAVED = 'Users.Profile' + EG.Users.Analytics.separator + 'Saved';

  // User Profile Analytics: Personal Info Section
  EG.Users.Profile.Analytics.personalInfo = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'PersonalInfo',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'PersonalInfo'
  };

  EG.Users.Profile.Analytics.preferences = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'Preferences',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'Preferences'
  };
  EG.Users.Profile.Analytics.preferences = _.extend(EG.Users.Profile.Analytics.preferences, {
    SAVED: EG.Users.Profile.Analytics.preferences.NAME + EG.Users.Analytics.separator + 'Saved',
    CONCUR_CONNECT_CLICKED: EG.Users.Profile.Analytics.preferences.NAME + EG.Users.Analytics.separator + 'ConcurConnect.Clicked'
  });
  // Declare name-spacing for all nested objects due to JS limitation
  // obj = { foo: 'foo', bar: obj.foo } won't work
  // obj = { foo: 'foo' }; obj.bar = obj.foo;
  EG.Users.Profile.Analytics.personalInfo = _.extend(EG.Users.Profile.Analytics.personalInfo, {
    FIRST_NAME: EG.Users.Profile.Analytics.personalInfo.NAME + EG.Users.Analytics.separator + 'FirstName',
    LAST_NAME: EG.Users.Profile.Analytics.personalInfo.NAME + EG.Users.Analytics.separator + 'LastName',
    REGIONAL_NAME: EG.Users.Profile.Analytics.personalInfo.NAME + EG.Users.Analytics.separator + 'RegionalName',
    MIDDLE_NAME: EG.Users.Profile.Analytics.personalInfo.NAME + EG.Users.Analytics.separator + 'MiddleName',
    PERSONAL_TITLE: EG.Users.Profile.Analytics.personalInfo.NAME + EG.Users.Analytics.separator + 'PersonalTitle',
    DATE_OF_BIRTH: EG.Users.Profile.Analytics.personalInfo.NAME + EG.Users.Analytics.separator + 'DateOfBirth',
    EMPLOYEE_ID: EG.Users.Profile.Analytics.personalInfo.NAME + EG.Users.Analytics.separator + 'EmployeeID',
    CITY_OF_BIRTH: EG.Users.Profile.Analytics.personalInfo.NAME + EG.Users.Analytics.separator + 'CityOfBirth',
    RESIDENCE_COUNTRY_CODE:
      EG.Users.Profile.Analytics.personalInfo.NAME + EG.Users.Analytics.separator + 'ResidenceCountryCode',
    JOB_TITLE: EG.Users.Profile.Analytics.personalInfo.NAME + EG.Users.Analytics.separator + 'JobTitle',
    STATUS: EG.Users.Profile.Analytics.personalInfo.NAME + EG.Users.Analytics.separator + 'Status',
    address: {
      NAME: EG.Users.Profile.Analytics.personalInfo.NAME + EG.Users.Analytics.separator + 'Address'
    },
    phone: {
      NAME: EG.Users.Profile.Analytics.personalInfo.NAME + EG.Users.Analytics.separator + 'Phone'
    },
    contactFee: {
      NAME: EG.Users.Profile.Analytics.personalInfo.NAME + EG.Users.Analytics.separator + 'ContactFee'
    }
  });
  EG.Users.Profile.Analytics.personalInfo.contactFee = _.extend(EG.Users.Profile.Analytics.personalInfo.contactFee, {
    APPLIED: EG.Users.Profile.Analytics.personalInfo.contactFee.NAME + EG.Users.Analytics.separator + 'Applied'
  });
  EG.Users.Profile.Analytics.personalInfo.statusAction = {
    APPROVE_SELECTED:
      EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Approve.Selected',
    APPROVE_CONFIRMED:
      EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Approve.Confirmed',
    APPROVE_CANCELLED:
      EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Approve.Cancelled',
    REJECT_SELECTED: EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Reject.Selected',
    REJECT_CONFIRMED:
      EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Reject.Confirmed',
    REJECT_WITH_NOTIFICATION_CONFIRMED:
      EG.Users.Profile.Analytics.personalInfo.STATUS +
      EG.Users.Analytics.separator +
      'RejectWithNotification.Confirmed',
    REJECT_WITH_NOTIFICATION_REASON_CONFIRMED:
      EG.Users.Profile.Analytics.personalInfo.STATUS +
      EG.Users.Analytics.separator +
      'RejectWithNotificationReason.Confirmed',
    REJECT_CANCELLED:
      EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Reject.Cancelled',
    ENABLE_SELECTED: EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Enable.Selected',
    ENABLE_CONFIRMED:
      EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Enable.Confirmed',
    ENABLE_CANCELLED:
      EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Enable.Cancelled',
    DISABLE_SELECTED:
      EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Disable.Selected',
    DISABLE_CONFIRMED:
      EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Disable.Confirmed',
    DISABLE_CANCELLED:
      EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Disable.Cancelled',
    DELETE_SELECTED: EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Delete.Selected',
    DELETE_CONFIRMED:
      EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Delete.Confirmed',
    DELETE_CANCELLED:
      EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Delete.Cancelled',
    UPDATE_CC_CLICKED:
      EG.Users.Profile.Analytics.personalInfo.STATUS + EG.Users.Analytics.separator + 'Update.CostCenter.Clicked'
  };

  // User Profile Analytics: Personal Info Section: ADDRESS
  EG.Users.Profile.Analytics.personalInfo.address = _.extend(EG.Users.Profile.Analytics.personalInfo.address, {
    ADDRESS_CHANGE:
      EG.Users.Profile.Analytics.personalInfo.address.NAME + EG.Users.Analytics.separator + 'AddressChange',
    COUNTRY: EG.Users.Profile.Analytics.personalInfo.address.NAME + EG.Users.Analytics.separator + 'CountryChange',
    LINE1: EG.Users.Profile.Analytics.personalInfo.address.NAME + EG.Users.Analytics.separator + 'Line1',
    LINE2: EG.Users.Profile.Analytics.personalInfo.address.NAME + EG.Users.Analytics.separator + 'Line2',
    DOOR_NUMBER: EG.Users.Profile.Analytics.personalInfo.address.NAME + EG.Users.Analytics.separator + 'Door',
    APARTMENT: EG.Users.Profile.Analytics.personalInfo.address.NAME + EG.Users.Analytics.separator + 'Apartment',
    CITY: EG.Users.Profile.Analytics.personalInfo.address.NAME + EG.Users.Analytics.separator + 'City',
    STATE: EG.Users.Profile.Analytics.personalInfo.address.NAME + EG.Users.Analytics.separator + 'State',
    ZIPCODE: EG.Users.Profile.Analytics.personalInfo.address.NAME + EG.Users.Analytics.separator + 'ZipCode'
  });

  // User Profile Analytics: Personal Info Section: PHONE
  EG.Users.Profile.Analytics.personalInfo.phone = _.extend(EG.Users.Profile.Analytics.personalInfo.phone, {
    MOBILE: EG.Users.Profile.Analytics.personalInfo.phone.NAME + EG.Users.Analytics.separator + 'Mobile',
    HOME: EG.Users.Profile.Analytics.personalInfo.phone.NAME + EG.Users.Analytics.separator + 'Home',
    WORK: EG.Users.Profile.Analytics.personalInfo.phone.NAME + EG.Users.Analytics.separator + 'Work',
    WORK_EXTENSION:
      EG.Users.Profile.Analytics.personalInfo.phone.NAME + EG.Users.Analytics.separator + 'Work.Extension',
    COUNTRY: EG.Users.Profile.Analytics.personalInfo.phone.NAME + EG.Users.Analytics.separator + 'CountryChange'
  });

  // User Profile Analytics: Emergency Contact Section
  EG.Users.Profile.Analytics.emergencyContact = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'EmergencyContact',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'EmergencyContact'
  };

  EG.Users.Profile.Analytics.emergencyContact = _.extend(EG.Users.Profile.Analytics.emergencyContact, {
    CREATED: EG.Users.Profile.Analytics.emergencyContact.NAME + EG.Users.Analytics.separator + 'Created',
    TM_VIEWED: EG.Users.Profile.Analytics.emergencyContact.NAME + EG.Users.Analytics.separator + 'TM.Viewed',
    DELETED: EG.Users.Profile.Analytics.emergencyContact.NAME + EG.Users.Analytics.separator + 'DELETED'
  });

  EG.Users.Profile.Analytics.personalInfo.common = {
    ARRANGEE_SELECTED: 'Users.Profile' + EG.Users.Analytics.separator + 'ArrangeeSelected',
    COMPANY_USER_SELECTED_BY_MANAGE_USER:
      'Users.Profile' + EG.Users.Analytics.separator + 'CompanyUserSelectedByManageUser',
    BACK_TO_SEARCH: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'BackToSearch'
  };

  EG.Users.Profile.Analytics.navigationLinks = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'NavigationLinks',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'NavigationLinks'
  };

  EG.Users.Profile.Analytics.travelDocuments = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'TravelDocuments',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'TravelDocuments'
  };

  EG.Users.Profile.Analytics.travelDocuments = _.extend(EG.Users.Profile.Analytics.travelDocuments, {
    PASSPORT: EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'Passport',
    ID: EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'Id',
    DRIVER_LICENSE: EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'Driver.License'
  });

  EG.Users.Profile.Analytics.travelDocuments.PASSPORT = {
    CREATED: EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'Passport.Created',
    DELETED: EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'Passport.Deleted',
    MODIFIED: EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'Passport.Modified'
  };

  EG.Users.Profile.Analytics.travelDocuments.ID = {
    CREATED: EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'Id.Created',
    DELETED: EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'Id.Deleted',
    MODIFIED: EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'Id.Modified'
  };

  EG.Users.Profile.Analytics.travelDocuments.DRIVER_LICENSE = {
    CREATED: EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'Driver.License.Created',
    DELETED: EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'Driver.License.Deleted',
    MODIFIED: EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'Driver.License.Modified'
  };

  EG.Users.Profile.Analytics.travelDocuments.TSA = {
    CREATED: EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'TSA.Created',
    DELETED: EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'TSA.Deleted',
    MODIFIED: EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'TSA.Modified'
  };

  EG.Users.Profile.Analytics.travelDocuments.SPECIAL_DOCUMENTS = {
    CREATED:
      EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'SPECIAL.DOCUMENTS.Created',
    DELETED:
      EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'SPECIAL.DOCUMENTS.Deleted',
    MODIFIED:
      EG.Users.Profile.Analytics.travelDocuments.NAME + EG.Users.Analytics.separator + 'SPECIAL.DOCUMENTS.Modified'
  };

  EG.Users.Profile.Analytics.userAssociations = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'UserAssociations',
    NAME: EG.Users.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'UserAssociations'
  };

  EG.Users.Profile.Analytics.userAssociations = _.extend(EG.Users.Profile.Analytics.userAssociations, {
    TRAVELER_GROUP_CHANGE:
      EG.Users.Profile.Analytics.userAssociations.NAME + EG.Users.Analytics.separator + 'Traveler.Group.Change',
    ROLE_UPDATE: EG.Users.Profile.Analytics.userAssociations.NAME + EG.Users.Analytics.separator + 'Role.Update',
    PERMISSION_ADD: EG.Users.Profile.Analytics.userAssociations.NAME + EG.Users.Analytics.separator + 'Permission.Add',
    PERMISSION_REMOVE: EG.Users.Profile.Analytics.userAssociations.NAME + EG.Users.Analytics.separator + 'Permission.Remove',
    GENERIC_ROLE_UPDATE:
      EG.Users.Profile.Analytics.userAssociations.NAME + EG.Users.Analytics.separator + 'Generic.Role.Update',
    ROLE_UPDATE_FAILED:
      EG.Users.Profile.Analytics.userAssociations.NAME + EG.Users.Analytics.separator + 'Role.Update.Failed'
  });

  // User arrangers and approvers
  EG.Users.Profile.Analytics.arrangeAndApprove = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'ArrangeAndApprove',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'ArrangeAndApprove'
  };

  EG.Users.Profile.Analytics.arrangeAndApprove = _.extend(EG.Users.Profile.Analytics.arrangeAndApprove, {
    ADD: EG.Users.Profile.Analytics.arrangeAndApprove.NAME + EG.Users.Analytics.separator + 'Add',
    REMOVE: EG.Users.Profile.Analytics.arrangeAndApprove.NAME + EG.Users.Analytics.separator + 'Remove',
    UPDATE: EG.Users.Profile.Analytics.arrangeAndApprove.NAME + EG.Users.Analytics.separator + 'Update',
    FILTER: {
      guest: EG.Users.Profile.Analytics.arrangeAndApprove.NAME + EG.Users.Analytics.separator + 'Filter.By.Guest',
      query: EG.Users.Profile.Analytics.arrangeAndApprove.NAME + EG.Users.Analytics.separator + 'Filter.By.Query'
    },
    LOAD_MORE: {
      all: EG.Users.Profile.Analytics.arrangeAndApprove.NAME + EG.Users.Analytics.separator + 'LoadMore.AllUsers',
      selected: EG.Users.Profile.Analytics.arrangeAndApprove.NAME + EG.Users.Analytics.separator + 'LoadMore.Selected'
    },
    ADDITIONAL_APPROVER: 'Additional.Approver'
  });

  // Analytics | User Profile : Cost Centers
  EG.Users.Profile.Analytics.costCenters = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'CostCenters',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'CostCenters'
  };

  // Analytics | User Profile : Change History
  EG.Users.Profile.Analytics.changeHistory = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'ChangeHistory',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'ChangeHistory'
  };

  EG.Users.Profile.Analytics.mobileAppInvite = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'MobileAppInvite',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'MobileAppInvite'
  };

  EG.Users.Profile.Analytics.mobileAppInvite = _.extend(EG.Users.Profile.Analytics.mobileAppInvite, {
    CLICKED: EG.Users.Profile.Analytics.mobileAppInvite.NAME + EG.Users.Analytics.separator + 'clicked',
    CONFIRMED: EG.Users.Profile.Analytics.mobileAppInvite.NAME + EG.Users.Analytics.separator + 'confimed',
    MODIFIED: EG.Users.Profile.Analytics.mobileAppInvite.NAME + EG.Users.Analytics.separator + 'modified',
    UPDATED_PROFILE: EG.Users.Profile.Analytics.mobileAppInvite.NAME + EG.Users.Analytics.separator + 'updated.profile'
  });

  EG.Users.Profile.Analytics.createUser = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'CreateUser',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'CreateUser',
    createTag: function(value) {
      return (
        EG.Users.Profile.Analytics.createUser.NAME +
        EG.Users.Analytics.separator +
        'Created' +
        EG.Users.Analytics.separator +
        'by' +
        EG.Users.Analytics.separator +
        mapRoleType(value)
      );
    }
  };

  EG.Users.Profile.Analytics.createUser = _.extend(EG.Users.Profile.Analytics.createUser, {
    NORMAL_USER: EG.Users.Profile.Analytics.createUser.NAME + EG.Users.Analytics.separator + 'normal',
    GUEST_USER: EG.Users.Profile.Analytics.createUser.NAME + EG.Users.Analytics.separator + 'guest',
    ERROR: EG.Users.Profile.Analytics.createUser.NAME + EG.Users.Analytics.separator + 'error',
    REGIONAL_NAME_CREATED:
      EG.Users.Profile.Analytics.createUser.NAME + EG.Users.Analytics.separator + 'RegionalName.created',
    ROLE_UPDATED: EG.Users.Profile.Analytics.createUser.NAME + EG.Users.Analytics.separator + 'Roles.updated',
    ARRANGERS_UPDATED: EG.Users.Profile.Analytics.createUser.NAME + EG.Users.Analytics.separator + 'Arrangers.updated',
    APPROVERS_UPDATED: EG.Users.Profile.Analytics.createUser.NAME + EG.Users.Analytics.separator + 'Approvers.updated',
    REQUIRE_WELCOME_EMAIL:
      EG.Users.Profile.Analytics.createUser.NAME + EG.Users.Analytics.separator + 'WelcomeEmail.Required',
    WELCOME_EMAIL_DEFAULT_LANGUAGE_CHANGED:
      EG.Users.Profile.Analytics.createUser.NAME + EG.Users.Analytics.separator + 'WelcomeEmailLanguage.changed'
  });

  EG.Users.Profile.Analytics.createGuestUser = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'CreateGuestUser',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'CreateGuestUser',
    createTag: function(value) {
      return (
        EG.Users.Profile.Analytics.createGuestUser.NAME +
        EG.Users.Analytics.separator +
        'Created' +
        EG.Users.Analytics.separator +
        'by' +
        EG.Users.Analytics.separator +
        mapRoleType(value)
      );
    }
  };

  EG.Users.Profile.Analytics.customDataFields = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'CustomDataFields',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'CustomDataFields'
  };

  EG.Users.Profile.Analytics.customDataFields = _.extend(EG.Users.Profile.Analytics.customDataFields, {
    MODIFIED: EG.Users.Profile.Analytics.customDataFields.NAME + EG.Users.Analytics.separator + 'Modified'
  });

  EG.Users.Profile.Analytics.createGuestUser = _.extend(EG.Users.Profile.Analytics.createGuestUser, {
    CREATE_SUCCESS: EG.Users.Profile.Analytics.createGuestUser.NAME + EG.Users.Analytics.separator + 'Create.success',
    CREATE_FAILED: EG.Users.Profile.Analytics.createGuestUser.NAME + EG.Users.Analytics.separator + 'Create.failed',
    DEFAULT_FIRST_NAME_MODIFIED:
      EG.Users.Profile.Analytics.createGuestUser.NAME + EG.Users.Analytics.separator + 'Default.First.Name.modified',
    DEFAULT_LAST_NAME_MODIFIED:
      EG.Users.Profile.Analytics.createGuestUser.NAME + EG.Users.Analytics.separator + 'Default.Last.Name.modified',
    REGIONAL_NAME_CREATED:
      EG.Users.Profile.Analytics.createGuestUser.NAME + EG.Users.Analytics.separator + 'RegionalName.created'
  });

  EG.Users.Profile.Analytics.selfRegistrationInvite = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'SelfRegistrationInvite',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'SelfRegistrationInvite'
  };

  EG.Users.Profile.Analytics.selfRegistrationInvite = _.extend(EG.Users.Profile.Analytics.selfRegistrationInvite, {
    LESS_THAN_100:
      EG.Users.Profile.Analytics.selfRegistrationInvite.NAME + EG.Users.Analytics.separator + 'LessThan100',
    BETWEEN_100_AND_200:
      EG.Users.Profile.Analytics.selfRegistrationInvite.NAME + EG.Users.Analytics.separator + 'Between100And200',
    BETWEEN_200_AND_300:
      EG.Users.Profile.Analytics.selfRegistrationInvite.NAME + EG.Users.Analytics.separator + 'Between200And300',
    BETWEEN_300_AND_400:
      EG.Users.Profile.Analytics.selfRegistrationInvite.NAME + EG.Users.Analytics.separator + 'Between300And400',
    BETWEEN_400_AND_500:
      EG.Users.Profile.Analytics.selfRegistrationInvite.NAME + EG.Users.Analytics.separator + 'Between400And500',
    GREATER_THAN_EQUAL_TO_500:
      EG.Users.Profile.Analytics.selfRegistrationInvite.NAME + EG.Users.Analytics.separator + 'GreaterThanEqualTo500',
    SAVE_TRAVEL_MANAGERS:
      EG.Users.Profile.Analytics.selfRegistrationInvite.NAME + EG.Users.Analytics.separator + 'NewRegistrationCustomNotifiers.Added'
  });

  EG.Users.Profile.Analytics.selfRegistration = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'SelfRegistration',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'SelfRegistration'
  };

  EG.Users.Profile.Analytics.selfRegistration = _.extend(EG.Users.Profile.Analytics.selfRegistration, {
    VIEW_COUNT: EG.Users.Profile.Analytics.selfRegistration.NAME + EG.Users.Analytics.separator + 'ViewCount',
    SUBMIT_COUNT: EG.Users.Profile.Analytics.selfRegistration.NAME + EG.Users.Analytics.separator + 'SubmitCount',
    REGIONAL_NAME_CREATED:
      EG.Users.Profile.Analytics.selfRegistration.NAME + EG.Users.Analytics.separator + 'RegionalName.created'
  });

  EG.Users.Profile.Analytics.selfRegistration.guest = {
    PAGE_NAME: EG.Users.Analytics.pagePrefix + EG.Users.Analytics.separator + 'Users' + EG.Users.Analytics.separator + 'SelfRegistration' + EG.Users.Analytics.separator + 'guest' + EG.Users.Analytics.separator + 'invite',
    NAME: 'Users' + EG.Users.Analytics.separator + 'SelfRegistration' + EG.Users.Analytics.separator + 'guest' + EG.Users.Analytics.separator + 'invite'
  };

  EG.Users.Profile.Analytics.selfRegistration.guest = _.extend(EG.Users.Profile.Analytics.selfRegistration.guest, {
    VIEW_COUNT: EG.Users.Profile.Analytics.selfRegistration.guest.NAME + EG.Users.Analytics.separator + 'ViewCount',
    SUBMIT_COUNT: EG.Users.Profile.Analytics.selfRegistration.guest.NAME + EG.Users.Analytics.separator + 'SubmitCount',
    REGIONAL_NAME_CREATED:
        EG.Users.Profile.Analytics.selfRegistration.guest.NAME + EG.Users.Analytics.separator + 'RegionalName' + EG.Users.Analytics.separator + 'created'
  });

  EG.Users.Profile.Analytics.accountSettings = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'AccountSettings',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'AccountSettings'
  };

  EG.Users.Profile.Analytics.accountSettings = _.extend(EG.Users.Profile.Analytics.accountSettings, {
    UPDATE: EG.Users.Profile.Analytics.accountSettings.NAME + EG.Users.Analytics.separator + 'Updated',
    updatedBy: {
      SELF:
        EG.Users.Profile.Analytics.accountSettings.NAME +
        EG.Users.Analytics.separator +
        'Updated' +
        EG.Users.Analytics.separator +
        EG.Users.Analytics.separator +
        'by' +
        'Self',
      OTHERS:
        EG.Users.Profile.Analytics.accountSettings.NAME +
        EG.Users.Analytics.separator +
        'Updated' +
        EG.Users.Analytics.separator +
        'by' +
        EG.Users.Analytics.separator +
        '{OTHERS}'
    },
    email: {
      UPDATE:
        EG.Users.Profile.Analytics.accountSettings.NAME +
        EG.Users.Analytics.separator +
        'EMAIL' +
        EG.Users.Analytics.separator +
        'Updated'
    },
    username: {
      UPDATE:
        EG.Users.Profile.Analytics.accountSettings.NAME +
        EG.Users.Analytics.separator +
        'USERNAME' +
        EG.Users.Analytics.separator +
        'Updated'
    },
    authentication: {
      UPDATE:
        EG.Users.Profile.Analytics.accountSettings.NAME +
        EG.Users.Analytics.separator +
        'AUTHENTICATION_MODE' +
        EG.Users.Analytics.separator +
        'Updated'
    },
    single_sign_on_id: {
      UPDATE:
        EG.Users.Profile.Analytics.accountSettings.NAME +
        EG.Users.Analytics.separator +
        'COMPANY_ID' +
        EG.Users.Analytics.separator +
        'Updated'
    },
    ESI: {
      VISITED:
        EG.Users.Profile.Analytics.accountSettings.NAME +
        EG.Users.Analytics.separator +
        'ESI' +
        EG.Users.Analytics.separator +
        'Visited',
      VISITED_BY: {
        SELF:
          EG.Users.Profile.Analytics.accountSettings.NAME +
          EG.Users.Analytics.separator +
          'ESI' +
          EG.Users.Analytics.separator +
          'Visited' +
          EG.Users.Analytics.separator +
          'by' +
          EG.Users.Analytics.separator +
          'Self',
        OTHERS:
          EG.Users.Profile.Analytics.accountSettings.NAME +
          EG.Users.Analytics.separator +
          'ESI' +
          EG.Users.Analytics.separator +
          'Visited' +
          EG.Users.Analytics.separator +
          'by' +
          EG.Users.Analytics.separator +
          '{OTHERS}'
      }
    },
    CHANGE_PASSWORD: {
      VISITED:
        EG.Users.Profile.Analytics.accountSettings.NAME +
        EG.Users.Analytics.separator +
        'CHANGE_PASSWORD' +
        EG.Users.Analytics.separator +
        'Visited',
      UPDATED:
        EG.Users.Profile.Analytics.accountSettings.NAME +
        EG.Users.Analytics.separator +
        'CHANGE_PASSWORD' +
        EG.Users.Analytics.separator +
        'Updated',
      CANCELLED:
        EG.Users.Profile.Analytics.accountSettings.NAME +
        EG.Users.Analytics.separator +
        'CHANGE_PASSWORD' +
        EG.Users.Analytics.separator +
        'Cancelled'
    },
    RESET_PASSWORD: {
      VISITED:
        EG.Users.Profile.Analytics.accountSettings.NAME +
        EG.Users.Analytics.separator +
        'RESET_PASSWORD' +
        EG.Users.Analytics.separator +
        'Visited',
      EMAIL_SENT:
        EG.Users.Profile.Analytics.accountSettings.NAME +
        EG.Users.Analytics.separator +
        'RESET_PASSWORD' +
        EG.Users.Analytics.separator +
        'EmailSent',
      EMAIL_FAILED:
        EG.Users.Profile.Analytics.accountSettings.NAME +
        EG.Users.Analytics.separator +
        'RESET_PASSWORD' +
        EG.Users.Analytics.separator +
        'EmailFailed',
      CANCELLED:
        EG.Users.Profile.Analytics.accountSettings.NAME +
        EG.Users.Analytics.separator +
        'RESET_PASSWORD' +
        EG.Users.Analytics.separator +
        'Cancelled'
    },
    VALIDITY_SETTINGS: {
       UPDATED:
         EG.Users.Profile.Analytics.accountSettings.NAME +
         EG.Users.Analytics.separator +
         'VALIDITY_SETTINGS' +
         EG.Users.Analytics.separator +
         'Updated',
    },
    EXEMPT_MFA: {
      SUCCESS:
          EG.Users.Profile.Analytics.accountSettings.NAME +
          EG.Users.Analytics.separator +
          'EXEMPT_MFA' +
          EG.Users.Analytics.separator +
          'Success',
      FAILURE:
          EG.Users.Profile.Analytics.accountSettings.NAME +
          EG.Users.Analytics.separator +
          'EXEMPT_MFA' +
          EG.Users.Analytics.separator +
          'Failure'
    }
  });

  EG.Users.Profile.Analytics.frequentTravelerAccounts = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'FrequentTravelerAccounts',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'FrequentTravelerAccounts'
  };

  EG.Users.Profile.Analytics.frequentTravelerAccounts = _.extend(EG.Users.Profile.Analytics.frequentTravelerAccounts, {
    created:
      EG.Users.Profile.Analytics.frequentTravelerAccounts.NAME +
      EG.Users.Analytics.separator +
      '{{lob}}' +
      EG.Users.Analytics.separator +
      '{{accountType}}' +
      EG.Users.Analytics.separator +
      'Created',
    updated:
      EG.Users.Profile.Analytics.frequentTravelerAccounts.NAME +
      EG.Users.Analytics.separator +
      '{{lob}}' +
      EG.Users.Analytics.separator +
      '{{accountType}}' +
      EG.Users.Analytics.separator +
      'Updated',
    deleted:
      EG.Users.Profile.Analytics.frequentTravelerAccounts.NAME +
      EG.Users.Analytics.separator +
      '{{lob}}' +
      EG.Users.Analytics.separator +
      '{{accountType}}' +
      EG.Users.Analytics.separator +
      'Deleted'
  });

  EG.Users.Profile.Analytics.ABTest = {
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'ABTest'
  };

  EG.Users.Profile.Analytics.ABTest = _.extend(EG.Users.Profile.Analytics.ABTest, {
    ADD_PASSPORT_VIEW_A:
      EG.Users.Profile.Analytics.ABTest.NAME + EG.Users.Analytics.separator + 'AddPassport.ViewA.Visited',
    ADD_PASSPORT_VIEW_A_LINK_CLICKED:
      EG.Users.Profile.Analytics.ABTest.NAME + EG.Users.Analytics.separator + 'AddPassport.ViewA.Link.Clicked',
    ADD_PASSPORT_VIEW_A_TAB_CLICKED:
      EG.Users.Profile.Analytics.ABTest.NAME + EG.Users.Analytics.separator + 'AddPassport.ViewA.Tab.Clicked',
    ADD_PASSPORT_VIEW_A_ADDED:
      EG.Users.Profile.Analytics.ABTest.NAME + EG.Users.Analytics.separator + 'AddPassport.ViewA.Added',
    ADD_PASSPORT_VIEW_A_TRAVEL_DOCUMENT_VISITED:
      EG.Users.Profile.Analytics.ABTest.NAME +
      EG.Users.Analytics.separator +
      'AddPassport.ViewA.TravelDocument.Visited',
    ADD_PASSPORT_VIEW_B:
      EG.Users.Profile.Analytics.ABTest.NAME + EG.Users.Analytics.separator + 'AddPassport.ViewB.Visited',
    ADD_PASSPORT_VIEW_B_ADDED:
      EG.Users.Profile.Analytics.ABTest.NAME + EG.Users.Analytics.separator + 'AddPassport.ViewB.Added',
    ADD_PASSPORT_VIEW_B_TRAVEL_DOCUMENT_VISITED:
      EG.Users.Profile.Analytics.ABTest.NAME +
      EG.Users.Analytics.separator +
      'AddPassport.ViewB.TravelDocument.Visited',
    ADD_PASSPORT_VIEW_C:
      EG.Users.Profile.Analytics.ABTest.NAME + EG.Users.Analytics.separator + 'AddPassport.ViewC.Visited',
    ADD_PASSPORT_VIEW_C_ADDED:
      EG.Users.Profile.Analytics.ABTest.NAME + EG.Users.Analytics.separator + 'AddPassport.ViewC.Added',
    ADD_PASSPORT_VIEW_C_TRAVEL_DOCUMENT_VISITED:
      EG.Users.Profile.Analytics.ABTest.NAME + EG.Users.Analytics.separator + 'AddPassport.ViewC.TravelDocument.Visited'
  });

  EG.Users.Profile.Analytics.paymentMeans = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'PaymentMeans',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'PaymentMeans'
  };

  EG.Users.Profile.Analytics.alertsAndCustomisations = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'AlertsAndCustomisations',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'AlertsAndCustomisations'
  };

  EG.Users.Profile.Analytics.paymentMeans.PAYMENT_MEANS = {
    CREATED: EG.Users.Profile.Analytics.paymentMeans.NAME + EG.Users.Analytics.separator + 'PAYMENT.MEANS.Created',
    UPDATED: EG.Users.Profile.Analytics.paymentMeans.NAME + EG.Users.Analytics.separator + 'PAYMENT.MEANS.Updated',
    DELETED: EG.Users.Profile.Analytics.paymentMeans.NAME + EG.Users.Analytics.separator + 'PAYMENT.MEANS.Deleted',
    ADD_CARD_LINK_CLICKED:
      EG.Users.Profile.Analytics.paymentMeans.NAME + EG.Users.Analytics.separator + 'AddCard.LINK.Clicked',
    EDIT_CARD_LINK_CLICKED:
      EG.Users.Profile.Analytics.paymentMeans.NAME + EG.Users.Analytics.separator + 'EditCard.LINK.Clicked',
    DELETE_CARD_LINK_CLICKED:
      EG.Users.Profile.Analytics.paymentMeans.NAME + EG.Users.Analytics.separator + 'DeleteCard.LINK.Clicked'
  };

  EG.Users.Profile.Analytics.alertsAndCustomisations.NOTIFICATION = {
    EXPIRY_ALERT_NOTIFICATION_CHANGED:
      EG.Users.Profile.Analytics.alertsAndCustomisations.NAME +
      EG.Users.Analytics.separator +
      'Expiry.Alert.Notification.Changed',
    CALENDER_INVITE_NOTIFICATION_CHANGED:
      EG.Users.Profile.Analytics.alertsAndCustomisations.NAME +
      EG.Users.Analytics.separator +
      'Calender.Invite.Notification.Changed',
    SAVED: EG.Users.Profile.Analytics.alertsAndCustomisations.NAME + EG.Users.Analytics.separator + 'Saved',
    reservationSettingsTag: function(value) {
      return EG.Users.Profile.Analytics.alertsAndCustomisations.NAME + EG.Users.Analytics.separator + value;
    }
  };

  EG.Users.Profile.Analytics.notificationPreferences = {
    PAGE_NAME: EG.Users.Profile.Analytics.PAGE_NAME + EG.Users.Analytics.separator + 'NotificationPreferences',
    NAME: 'Users.Profile' + EG.Users.Analytics.separator + 'NotificationPreferences'
  };

  EG.Users.Profile.Analytics.notificationPreferences = _.extend(EG.Users.Profile.Analytics.notificationPreferences, {
    flightAlerts: {
      visited:
        EG.Users.Profile.Analytics.notificationPreferences.NAME + EG.Users.Analytics.separator + 'FlightAlerts.visited',
      created:
        EG.Users.Profile.Analytics.notificationPreferences.NAME + EG.Users.Analytics.separator + 'FlightAlerts.created',
      updated:
        EG.Users.Profile.Analytics.notificationPreferences.NAME + EG.Users.Analytics.separator + 'FlightAlerts.updated',
      deleted:
        EG.Users.Profile.Analytics.notificationPreferences.NAME + EG.Users.Analytics.separator + 'FlightAlerts.deleted',
      deliveryMethod: {
        email:
          EG.Users.Profile.Analytics.notificationPreferences.NAME +
          EG.Users.Analytics.separator +
          'FlightAlerts.deliveryMethod.email',
        mobile:
          EG.Users.Profile.Analytics.notificationPreferences.NAME +
          EG.Users.Analytics.separator +
          'FlightAlerts.deliveryMethod.mobile'
      },
      alerts:
        EG.Users.Profile.Analytics.notificationPreferences.NAME +
        EG.Users.Analytics.separator +
        'FlightAlerts.alerts' +
        EG.Users.Analytics.separator +
        '{{alert}}'
    }
  });

  // User Profile Analytics: END

  // POS specifics
  if (EG.isNA) {
    EG.Users.Constants.PRIMARY_INDIVIDUAL_ADDRESS_CODE = '1';
  }

  EG.Users.Profile.Error = {
    Descriptions: {
      'ege-user-1117': 'create_user_errorMsg_username_exists',
      'EGE-USER-1117' : 'create_user_errorMsg_username_exists',
      'ege-user-1134': 'create_user_errorMsg_ssoid_exists',
      'ege-user-1021': 'userInfo_validation_email_invalid',
      'EGE-USER-1146': 'user_status_action_delete_error_message_ege-user-1146',
      'EGE-USER-1147': 'user_status_action_delete_error_message_ege-user-1147',
      'EGE-USER-1484': 'user_status_action_disable_error_message_ege-user-1484',
      'EGE-USER-1148': 'user_status_action_delete_error_message_ege-user-1148',
      'EGE-USER-1180': 'user_can_not_be_added_as_arranger_ege-user-1180',
      'EGE-USER-1149': 'user_status_action_delete_error_message_ege-user-1149',
      'EGE-USER-1150': 'user_status_action_delete_error_message_ege-user-1150',
      'EGE-USER-1151': 'user_status_action_delete_error_message_ege-user-1151',
      'EGE-USER-1042': 'user_status_action_delete_error_message_ege-user-1042',
      'EGE-USER-1094': 'user_status_action_delete_error_message_ege-user-1094',
      'ege-user-generic_delete': 'user_status_action_delete_error_message',
      'ege-user-1159': 'frequent_traveler_account_invalid_lob',
      'ege-user-1160': 'frequent_traveler_account_invalid_card_number',
      'ege-user-1161': 'frequent_traveler_account_invalid_card_number',
      'ege-user-1162': 'frequent_traveler_account_invalid_rail_class',
      'ege-user-1163': 'frequent_traveler_account_duplicate_program',
      'ege-user-1164': 'frequent_traveler_account_invalid_card_format',
      'SERVICE_LEVEL_COUNT_EXCEEDED' : 'error_msg_service_level_count_exceeded',
      duplicate_record_exception: 'DUPLICATE_RECORD_EXCEPTION',
      '10-4': 'DUPLICATE_CONTACT_EXCEPTION',
      'ege-user-1145': 'invalid_user_name_ege-user-1145',
      'EGE-USER-1080': 'card_not_valid',
      'EGE-USER-1070': 'date_not_valid',
      'EGE-USER-1075': 'card_not_valid',
      'EGE-USER-1077': 'country_not_valid',
      'EGE-USER-1188': 'card_not_valid',
      'EGE-USER-1187': 'date_not_valid',
      'EGE-USER-1186': 'card_not_valid',
      'EGE-USER-1189': 'card_not_valid',
      'EGE-USER-1184': 'payment_means_duplicate_card_desc_error',
      'ege-user-1065' : 'invalid_parameters',
      'ege-captcha-001' : 'CAPTCHA_INCORRECT',
      'EGE-USER-1197': 'payment_card_doesnot_exist',
      'EGE-USER-1198' : 'griffin_token_invalid',
      'EGE-USER-1199' : 'traveler_not_found',
      'EGE-USER-1200' : 'customer_not_found',
      'EGE-USER-1201' : 'user_not_found_in_navision',
      'EGE-USER-1202' : 'open_transaction_exists',
      'EGE-USER-1204' : 'cost_center_not_found',
      'EGE-USER-1205' : 'card_status_pending',
      'EGE-USER-1206' : 'invalid_profile_approvers',
      'EGE-USER-1215' : 'personal_account_number_not_valid',
      'EGE-USER-1216' : 'credit_card_type_unknown',
      'EGE-USER-1217' : 'is_lodged_card',
      'EGE-USER-1218' : 'primary_account_linked_error',
      'EGE-USER-1219' : 'primary_account_linked_error',
      'EGE-USER-1470' : 'user_status_action_disable_error_message_ege-user-1470',
      'EGE-USER-1472' : 'only_corporate_credit_card_allowed',
      'EGE-GGU-008': 'global_guest_creation_error',
      'EGE-USER-1481': 'approver_approvee_assignment_error',
      'EGE-USER-1482': 'approver_approvee_unassignment_error',
      'ARRANGER-GROUP-UPDATE-FAILED':'arranger_group_update_failed',
      'DUPLICATE_RECORD_EXCEPTION': 'duplicate_arranger_group',
      'EGE-USER-1134': 'create_user_errorMsg_ssoid_exists',
      'EGE-USER-1221': 'card_not_supported_for_the_market',
      'ege-user-1063': 'username_already_exists',
      'ege-user-1491' : 'userInfo_validation_phone_invalid' ,
      'EGE-USER-1491' : 'userInfo_validation_phone_invalid'
    },
    global_guest: {
      'ege-user-1117': 'create_user_errorMsg_user_name_exists',
      'EGE-USER-1117' : 'create_user_errorMsg_user_name_exists'
    }
  };

  EG.Users.guestBooking.Error = {
    'EGE-UIT-012': 'template_creator_cannot_be_removed_from_owners',
    'EGE-UIT-014' : 'owner_required_for_private_template',
    'EGE-UIT-015' : 'admins_can_be_template_owners_only',
    'EGE-UIT-017' : 'invite_template_cannot_be_created_with_duplicate_name'
  };

  EG.Users.Profile.TemplatingConfig = {
    Names: {
      personalInformation: 'personal_info',
      arrangeAndApprove: 'arrange_and_approve',
      changeHistory: 'change_history',
      costCenters: 'cost_centers',
      createUser: 'create_user',
      createUserNew: 'create_user_new',
      emergencyContacts: 'emergency_contacts',
      travelDocuments: 'travel_documents',
      userAssociations: 'user_associations',
	  createGuestUser: 'create_guest_user',
	  createGuestUserNew: 'create_guest_user_new',
      customDataFields: 'custom_data_fields',
      accountSettings: 'account_settings',
      frequentTravelerAccounts: 'frequent_traveler_accounts',
      notificationPreferences: 'notification_preferences',
      preferences: 'preferences',
      paymentMeans: 'payment_means',
      createGlobalGuestUser: 'create_global_guest_user',
      createGlobalGuestUserNew: 'create_global_guest_user_new'
    }
  };

  // To cache any local data
  EG.Users.Profile.Data = {};

  EG.Users.ProfileCompletion.Constants = {
      EDIT_NAME_FORM: 'editNameForm',
      EDIT_PHONE_FORM: 'editPhoneForm',
      EDIT_DOB_FORM: 'editDOBForm'
  };

})(EG);
